import { createUserToken } from "./createUserToken";

// Store clicked items along with queryID to pass as conversion event on confirmation page
export const persistConversionData = (clickObj) => {
  const conversionData = JSON.parse(sessionStorage.getItem("algolia-analytics-conversion"));
  const newConversionData = {
    queryID: clickObj.queryID,
    index: clickObj.index,
    objectIDs: Array.from(
      new Set(conversionData === null ? [...clickObj.objectIDs] : [...conversionData.objectIDs, ...clickObj.objectIDs])
    ),
    positions: Array.from(
      new Set(conversionData === null ? [...clickObj.positions] : [...conversionData.positions, ...clickObj.positions])
    ),
    userToken: conversionData?.userToken ?? clickObj?.userToken ?? createUserToken(),
  };
  sessionStorage.setItem("algolia-analytics-conversion", JSON.stringify(newConversionData));
  return newConversionData;
};